/* Hook encargado de hacer la consulta a la base y 
traer  el contenido de los body de los vehiculos

Autor: Benjamín León
Fecha: 2024-08-25
*/
import { useState } from 'react'

import { customFetch } from '../utils/customFetch.ts'

import {
  makeUrlChaBodies,
  makeUrlChaBrands,
  makeUrlChaModels,
  makeUrlChaFuel,
  makeUrlChaGearbox,
  makeUrlChaTypes,
  makeUrlColor,
} from './connectionData.tsx'

const useChaFetcher = () => {
  const [errorChaBrands, setErrorChaBrands] = useState<Error | null>(null)

  const [errorChaModels, setErrorChaModels] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [errorChaTypes, setErrorChaTypes] = useState<Error | null>(null)
  const [errorChaBodies, setErrorChaBodies] = useState<Error | null>(null)
  const [errorChaFuel, setErrorChaFuel] = useState<Error | null>(null)
  const [errorChaGearbox, setErrorChaGearbox] = useState<Error | null>(null)
  const [errorChaColor, setErrorChaColor] = useState<Error | null>(null)

  const chaModels = async (brand: string, vehicleType?: string) => {
    setLoading(true)
    const params = new URLSearchParams({
      brand: brand,
    })

    try {
      const apiUrl = makeUrlChaModels(params, vehicleType)
      const data = await customFetch<string[]>(apiUrl)
      setErrorChaModels(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorChaModels(err)
      } else {
        setErrorChaModels(new Error('An unknown error occurred'))
      }

      return []
    } finally {
      setLoading(false)
    }
  }

  const chaBrands = async (vehicleType?: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlChaBrands(vehicleType)
      const data = await customFetch<string[]>(apiUrl)
      setErrorChaBrands(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorChaBrands(err)
      } else {
        setErrorChaBrands(new Error('An unknown error occurred'))
      }

      return []
    } finally {
      setLoading(false)
    }
  }

  const chaBodies = async (vehicleType?: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlChaBodies(vehicleType)
      //      const data = await customFetch<VehicleBody[]>(apiUrl);
      const data = await customFetch<Record<string, string>>(apiUrl)
      setErrorChaBodies(null)

      // Eliminamos los que empiezan con "_"
      // const filteredBodyTranslate: Record<string, string> = Object.fromEntries(
      //   Object.entries(data).filter(([key]) => !key.startsWith("_"))
      // );
      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorChaBodies(err)
      } else {
        setErrorChaBodies(new Error('An unknown error occurred'))
      }

      return {}
    } finally {
      setLoading(false)
    }
  }

  const chaTypes = async () => {
    setLoading(true)

    try {
      const apiUrl = makeUrlChaTypes()
      //const data = await customFetch<VehicleType[]>(apiUrl);
      const data = await customFetch<Record<string, string>>(apiUrl)

      setErrorChaTypes(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorChaTypes(err)
      } else {
        setErrorChaTypes(new Error('An unknown error occurred'))
      }

      return {}
    } finally {
      setLoading(false)
    }
  }

  const chaFuel = async () => {
    setLoading(true)

    try {
      const apiUrl = makeUrlChaFuel()
      const data = await customFetch<string[]>(apiUrl)
      setErrorChaFuel(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorChaFuel(err)
      } else {
        setErrorChaFuel(new Error('An unknown error occurred'))
      }

      return []
    } finally {
      setLoading(false)
    }
  }

  const chaGearbox = async () => {
    setLoading(true)

    try {
      const apiUrl = makeUrlChaGearbox()
      const data = await customFetch<string[]>(apiUrl)
      setErrorChaGearbox(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorChaGearbox(err)
      } else {
        setErrorChaGearbox(new Error('An unknown error occurred'))
      }

      return []
    } finally {
      setLoading(false)
    }
  }
  const chaColor = async () => {
    setLoading(true)

    try {
      const apiUrl = makeUrlColor()
      const data = await customFetch<string[]>(apiUrl)
      setErrorChaColor(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorChaColor(err)
      } else {
        setErrorChaColor(new Error('An unknown error occurred'))
      }

      return []
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return {
    loading,
    chaTypes,
    chaBodies,
    chaBrands,
    chaModels,
    chaFuel,
    chaGearbox,
    chaColor,
    errorChaTypes,
    errorChaBodies,
    errorChaBrands,
    errorChaModels,
    errorChaFuel,
    errorChaGearbox,
    errorChaColor,
  }
}

export default useChaFetcher
